import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Mail, Phone, MapPin, Facebook, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const handleCTAClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open('https://calendly.com/beratung-ciafardini-consulting/30min', '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="bg-white border-t border-gray-200 pt-20 pb-10">
      <div className="container mx-auto px-6">
        {/* CTA Section */}
        <div className="mb-16 text-center">
          <div className="bg-secondary-200 rounded-xl p-8 max-w-4xl mx-auto shadow-md">
            <h3 className="text-2xl md:text-3xl font-bold mb-4 text-gray-900">
              Bereit für den nächsten Schritt?
            </h3>
            <p className="text-gray-700 mb-8 max-w-2xl mx-auto">
              Lassen Sie uns gemeinsam das perfekte Benefits-Werk für Ihr Unternehmen entwickeln.
            </p>
            <button 
              onClick={handleCTAClick}
              className="btn btn-primary btn-lg flex items-center gap-2 mx-auto">
              Kostenfreie Potentialanalyse
              <ArrowRight size={20} />
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="block">
              <img 
                src="/images/benefitwerk logo.png" 
                alt="BenefitWerk Logo" 
                className="h-20 md:h-24 w-auto object-contain mb-4 transition-all duration-300"
              />
            </Link>
            <p className="text-gray-600">Ihr Partner für betriebliche Gesundheitsvorsorge und Mitarbeiterbindung.</p>
            <div className="flex gap-4">
              <a href="https://facebook.com" aria-label="Facebook" className="text-gray-400 hover:text-primary-500 transition-colors">
                <Facebook size={24} />
              </a>
              <a href="https://linkedin.com" aria-label="LinkedIn" className="text-gray-400 hover:text-primary-500 transition-colors">
                <Linkedin size={24} />
              </a>
              <a href="https://instagram.com" aria-label="Instagram" className="text-gray-400 hover:text-primary-500 transition-colors">
                <Instagram size={24} />
              </a>
            </div>
          </div>

          {/* Contact */}
          <address className="space-y-6 not-italic">
            <h4 className="text-lg font-bold text-gray-900">Kontakt</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Mail className="text-primary-500 w-5 h-5" />
                <a href="mailto:info@benefitwerk.de" className="text-gray-600 hover:text-primary-500 transition-colors">info@benefitwerk.de</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="text-primary-500 w-5 h-5" />
                <a href="tel:+4917681237159" className="text-gray-600 hover:text-primary-500 transition-colors">+49 176 81237159</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="text-primary-500 w-5 h-5 mt-1" />
                <span className="text-gray-600">
                  Eyachstraße 37<br />71065 Sindelfingen<br />Deutschland
                </span>
              </li>
            </ul>
          </address>

          {/* Quick Access */}
          <nav aria-label="Schnellzugriff" className="space-y-6">
            <h4 className="text-lg font-bold text-gray-900">Schnellzugriff</h4>
            <ul className="space-y-3">
              <li><a href="#benefits-highlights" className="text-gray-600 hover:text-primary-500 transition-colors">Unternehmensvorteile</a></li>
              <li><a href="#pain-points" className="text-gray-600 hover:text-primary-500 transition-colors">Herausforderungen</a></li>
              <li><a href="#health-is" className="text-gray-600 hover:text-primary-500 transition-colors">Gesundheit</a></li>
              <li><a href="#employee-employer" className="text-gray-600 hover:text-primary-500 transition-colors">Mitarbeiter & Unternehmen</a></li>
              <li><a href="#how-it-works" className="text-gray-600 hover:text-primary-500 transition-colors">Unser Vorgehen</a></li>
              <li><a href="#faq" className="text-gray-600 hover:text-primary-500 transition-colors">Häufige Fragen</a></li>
            </ul>
          </nav>

          {/* Legal */}
          <nav aria-label="Rechtliches" className="space-y-6">
            <h4 className="text-lg font-bold text-gray-900">Rechtliches</h4>
            <ul className="space-y-3">
              <li><Link to="/impressum" className="text-gray-600 hover:text-primary-500 transition-colors">Impressum</Link></li>
              <li><Link to="/datenschutz" className="text-gray-600 hover:text-primary-500 transition-colors">Datenschutz</Link></li>
              <li><Link to="/kundenerstinfo" className="text-gray-600 hover:text-primary-500 transition-colors">Kundenerstinfo</Link></li>
              <li>
                <a 
                  href="#cookie-policy" 
                  className="text-gray-600 hover:text-primary-500 transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cookie-Richtlinie
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <p className="text-center text-gray-500">© 2025 BenefitWerk. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;